import { BaseModel } from "../../../vendor_core/core/src/model/BaseModel";
import { MaybeUndefined } from "../types/BURGameTypes";
import {
    Fragment,
    Jackpot,
    JackpotConfig,
    JackpotWin
} from "../types/IBURJackpotsModel";

class BURJackpotsModel extends BaseModel<Jackpot> {
    private tiers: Jackpot[] = ["MINI", "MINOR", "MEDIUM", "MAJOR", "MEGA"];
    private jackpotsProgress: Record<Jackpot, number> = {
        MINI: 0,
        MINOR: 0,
        MEDIUM: 0,
        MAJOR: 0,
        MEGA: 0
    };
    private jackpotWins: JackpotWin[] = [];
    private currentJackpotWin: number = 0;
    private fragments: Fragment[] = [];
    private jackpotsConfig: MaybeUndefined<Record<Jackpot, JackpotConfig>> =
        undefined;

    public get jackpots_progress() {
        return this.jackpotsProgress;
    }

    public get jackpot_wins() {
        return this.jackpotWins;
    }

    public get jackpot_fragments() {
        return this.fragments;
    }

    public get jackpots_config() {
        return this.jackpotsConfig;
    }

    public get jackpot_tiers() {
        return this.tiers;
    }

    public get current_jackpot_win() {
        return this.currentJackpotWin;
    }

    public setJackpotsConfig(payload: Record<Jackpot, JackpotConfig>) {
        this.jackpotsConfig = payload;
    }

    public incrementJackpotProgress(tier: Jackpot) {
        this.jackpotsProgress[tier]++;
    }

    public resetJackpotProgress(tier: Jackpot) {
        this.jackpotsProgress[tier] = 0;
    }

    public setJackpotWins(payload: JackpotWin[]) {
        this.jackpotWins = payload;
    }

    public setCurrentJackpotWin(payload: number) {
        this.currentJackpotWin = payload;
    }

    public setJackpotFragments(payload: Fragment[]) {
        this.fragments = payload;
    }

    public resetAllJackpots() {
        this.jackpot_tiers.forEach((tier) => {
            this.resetJackpotProgress(tier);
        });
    }
}

export default new BURJackpotsModel();
